// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JointDetails_root__3TY3c {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
}
.JointDetails_root__3TY3c section {
  color: #111111;
  overflow: hidden;
}
.JointDetails_root__3TY3c section header {
  display: flex;
  justify-content: space-between;
}
.JointDetails_root__3TY3c section header .JointDetails_title__eaCMg {
  font-size: 15px;
}
.JointDetails_root__3TY3c section .JointDetails_field__G3fow {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 1;
}
.JointDetails_root__3TY3c section .JointDetails_field__G3fow .JointDetails_label__GxiNU {
  color: rgba(17, 17, 17, 0.568627451);
  margin-bottom: 4px;
}
.JointDetails_root__3TY3c section .JointDetails_field__G3fow .JointDetails_value__pmQdi {
  display: flex;
  align-items: center;
  gap: 2px;
}
.JointDetails_root__3TY3c .JointDetails_title__eaCMg {
  padding: 16px 2px;
  font-size: 16px;
  font-weight: 300;
  color: #111111;
}
.JointDetails_root__3TY3c .nav-link {
  cursor: pointer;
}

.JointDetails_tabs__imSeW {
  display: flex;
  gap: 16px;
  justify-content: center;
  padding-bottom: 24px;
}
.JointDetails_tabs__imSeW li {
  cursor: pointer;
  line-height: 1.4;
}
.JointDetails_tabs__imSeW .active {
  border-bottom: 1px solid grey;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/JointDetails/JointDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACF;AAAE;EACE,cAAA;EACA,gBAAA;AAEJ;AADI;EACE,aAAA;EACA,8BAAA;AAGN;AAFM;EACE,eAAA;AAIR;AADI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAGN;AADM;EACE,oCAAA;EACA,kBAAA;AAGR;AAAM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAER;AAGE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;AAFJ;;AAMA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;AAHF;AAIE;EACE,eAAA;EACA,gBAAA;AAFJ;AAIE;EACE,6BAAA;AAFJ","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-top: 16px;\r\n  margin-bottom: 32px;\r\n  section {\r\n    color: #111111;\r\n    overflow: hidden;\r\n    header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      .title {\r\n        font-size: 15px;\r\n      }\r\n    }\r\n    .field {\r\n      display: flex;\r\n      flex-direction: column;\r\n      font-size: 14px;\r\n      line-height: 1;\r\n\r\n      .label {\r\n        color: #11111191;\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      .value {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 2px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .title {\r\n    padding: 16px 2px;\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n    color: #111111;\r\n  }\r\n\r\n  :global(.nav-link) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n  padding-bottom: 24px;\r\n  li {\r\n    cursor: pointer;\r\n    line-height: 1.4;\r\n  }\r\n  :global(.active) {\r\n    border-bottom: 1px solid grey;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JointDetails_root__3TY3c`,
	"title": `JointDetails_title__eaCMg`,
	"field": `JointDetails_field__G3fow`,
	"label": `JointDetails_label__GxiNU`,
	"value": `JointDetails_value__pmQdi`,
	"tabs": `JointDetails_tabs__imSeW`
};
export default ___CSS_LOADER_EXPORT___;
